export const itemInitOptions = {
  colId: '',
  optionId: '',
  photos: null,
  rowId: '',
  value: ''
}
